"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMediaRecorderObserver = exports.IFaceInfoObserver = exports.IVideoFrameObserver = exports.IVideoEncodedFrameObserver = exports.IAudioSpectrumObserver = exports.IAudioFrameObserver = exports.IAudioFrameObserverBase = exports.IAudioPcmFrameSink = exports.IVideoFrameMetaInfoDispatch = void 0;
const native_rtc_1 = require("@iris/native-rtc");
const iris_web_core_1 = require("iris-web-core");
const EventhandlerBufferExtensions_1 = require("../extensions/EventhandlerBufferExtensions");
const AgoraConsole_1 = require("../util/AgoraConsole");
class IVideoFrameMetaInfoDispatch {
    constructor(engine) {
        this._engine = engine;
    }
    // @ts-ignore
    getMetaInfoStr_c81192f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameMetaInfo_getMetaInfoStr_c81192f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IVideoFrameMetaInfoDispatch = IVideoFrameMetaInfoDispatch;
class IAudioPcmFrameSink {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onFrame_95f515a(frame) {
        AgoraConsole_1.AgoraConsole.warn('AudioPcmFrameSink_onFrame_95f515a not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IAudioPcmFrameSink = IAudioPcmFrameSink;
class IAudioFrameObserverBase {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onRecordAudioFrame_4c8de15(channelId, audioFrame) {
        AgoraConsole_1.AgoraConsole.warn('AudioFrameObserver_onRecordAudioFrame_4c8de15 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onPlaybackAudioFrame_4c8de15(channelId, audioFrame) {
        let _obj = {
            channelId,
            audioFrame,
        };
        let bufferList = (0, EventhandlerBufferExtensions_1.eventHandlerBufferExtension)('AudioFrameObserver_onPlaybackAudioFrame_4c8de15', _obj);
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('AudioFrameObserver_onPlaybackAudioFrame_4c8de15', _json, 0, '', bufferList, [], bufferList.length);
        this.notifyEvent(eventParam);
    }
    onMixedAudioFrame_4c8de15(channelId, audioFrame) {
        AgoraConsole_1.AgoraConsole.warn('AudioFrameObserver_onMixedAudioFrame_4c8de15 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onEarMonitoringAudioFrame_5405a47(audioFrame) {
        AgoraConsole_1.AgoraConsole.warn('AudioFrameObserver_onEarMonitoringAudioFrame_5405a47 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onPlaybackAudioFrameBeforeMixing_9215cc7(channelId, userId, audioFrame) {
        AgoraConsole_1.AgoraConsole.warn('AudioFrameObserver_onPlaybackAudioFrameBeforeMixing_9215cc7 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IAudioFrameObserverBase = IAudioFrameObserverBase;
class IAudioFrameObserver extends IAudioFrameObserverBase {
    constructor(engine) {
        super(engine);
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onPlaybackAudioFrameBeforeMixing_85ec0fc(channelId, uid, audioFrame) {
        AgoraConsole_1.AgoraConsole.warn('AudioFrameObserver_onPlaybackAudioFrameBeforeMixing_85ec0fc not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRecordAudioFrame_4c8de15(channelId, audioFrame) {
        AgoraConsole_1.AgoraConsole.warn('AudioFrameObserver_onRecordAudioFrame_4c8de15 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onPlaybackAudioFrame_4c8de15(channelId, audioFrame) {
        let _obj = {
            channelId,
            audioFrame,
        };
        let bufferList = (0, EventhandlerBufferExtensions_1.eventHandlerBufferExtension)('AudioFrameObserver_onPlaybackAudioFrame_4c8de15', _obj);
        let _json = JSON.stringify(_obj);
        let eventParam = new iris_web_core_1.IrisCore.EventParam('AudioFrameObserver_onPlaybackAudioFrame_4c8de15', _json, 0, '', bufferList, [], bufferList.length);
        this.notifyEvent(eventParam);
    }
    onMixedAudioFrame_4c8de15(channelId, audioFrame) {
        AgoraConsole_1.AgoraConsole.warn('AudioFrameObserver_onMixedAudioFrame_4c8de15 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onEarMonitoringAudioFrame_5405a47(audioFrame) {
        AgoraConsole_1.AgoraConsole.warn('AudioFrameObserver_onEarMonitoringAudioFrame_5405a47 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onPlaybackAudioFrameBeforeMixing_9215cc7(channelId, userId, audioFrame) {
        AgoraConsole_1.AgoraConsole.warn('AudioFrameObserver_onPlaybackAudioFrameBeforeMixing_9215cc7 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IAudioFrameObserver = IAudioFrameObserver;
class IAudioSpectrumObserver {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onLocalAudioSpectrum_5822fed(data) {
        AgoraConsole_1.AgoraConsole.warn('AudioSpectrumObserver_onLocalAudioSpectrum_5822fed not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRemoteAudioSpectrum_8ea2cde(spectrums, spectrumNumber) {
        AgoraConsole_1.AgoraConsole.warn('AudioSpectrumObserver_onRemoteAudioSpectrum_8ea2cde not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IAudioSpectrumObserver = IAudioSpectrumObserver;
class IVideoEncodedFrameObserver {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onEncodedVideoFrameReceived_6922697(uid, imageBuffer, length, videoEncodedFrameInfo) {
        AgoraConsole_1.AgoraConsole.warn('VideoEncodedFrameObserver_onEncodedVideoFrameReceived_6922697 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IVideoEncodedFrameObserver = IVideoEncodedFrameObserver;
class IVideoFrameObserver {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onCaptureVideoFrame_1673590(sourceType, videoFrame) {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameObserver_onCaptureVideoFrame_1673590 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onPreEncodeVideoFrame_1673590(sourceType, videoFrame) {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameObserver_onPreEncodeVideoFrame_1673590 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onMediaPlayerVideoFrame_e648e2c(videoFrame, mediaPlayerId) {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameObserver_onMediaPlayerVideoFrame_e648e2c not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRenderVideoFrame_43dcf82(channelId, remoteUid, videoFrame) {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameObserver_onRenderVideoFrame_43dcf82 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onTranscodedVideoFrame_27754d8(videoFrame) {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameObserver_onTranscodedVideoFrame_27754d8 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    getVideoFrameProcessMode() {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameObserver_getVideoFrameProcessMode not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    getVideoFormatPreference() {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameObserver_getVideoFormatPreference not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    getRotationApplied() {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameObserver_getRotationApplied not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    getMirrorApplied() {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameObserver_getMirrorApplied not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    getObservedFramePosition() {
        AgoraConsole_1.AgoraConsole.warn('VideoFrameObserver_getObservedFramePosition not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IVideoFrameObserver = IVideoFrameObserver;
class IFaceInfoObserver {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onFaceInfo_3a2037f(outFaceInfo) {
        AgoraConsole_1.AgoraConsole.warn('FaceInfoObserver_onFaceInfo_3a2037f not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IFaceInfoObserver = IFaceInfoObserver;
class IMediaRecorderObserver {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onRecorderStateChanged_c38849f(channelId, uid, state, reason) {
        AgoraConsole_1.AgoraConsole.warn('MediaRecorderObserver_onRecorderStateChanged_c38849f not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onRecorderInfoUpdated_64fa74a(channelId, uid, info) {
        AgoraConsole_1.AgoraConsole.warn('MediaRecorderObserver_onRecorderInfoUpdated_64fa74a not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IMediaRecorderObserver = IMediaRecorderObserver;
